import type React from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";

interface VentiHandoffProps {
  eyebrow: string;
  title: string;
  description: string;
  destination: string;
  redirect?: (destination: string) => void;
}

const assignDestination = (destination: string) => {
  window.location.assign(destination);
};

const VentiHandoff: React.FC<VentiHandoffProps> = ({
  eyebrow,
  title,
  description,
  destination,
  redirect = assignDestination,
}) => {
  useEffect(() => {
    const timeout = window.setTimeout(() => {
      redirect(destination);
    }, 1800);

    return () => window.clearTimeout(timeout);
  }, [destination, redirect]);

  return (
    <section
      className="site-shell flex min-h-[68vh] items-center py-16"
      data-destination={destination}
      data-testid="legacy-handoff"
    >
      <div className="w-full rounded-[2rem] bg-[#4b2e83] px-6 py-14 text-white shadow-2xl sm:px-12 lg:px-20">
        <p className="eyebrow text-emerald-300">{eyebrow}</p>
        <h1 className="mt-4 max-w-3xl text-4xl font-black tracking-tight sm:text-6xl">
          {title}
        </h1>
        <p className="mt-6 max-w-2xl text-lg leading-8 text-violet-100">
          {description}
        </p>
        <p className="mt-8 text-sm font-bold uppercase tracking-[0.18em] text-emerald-200">
          The current personal experience will open automatically.
        </p>
        <Link
          className="mt-7 inline-flex rounded-full border border-violet-300/50 px-5 py-2.5 font-extrabold text-white transition hover:bg-violet-900"
          to="/"
        >
          Stay on the Washington ARML site
        </Link>
      </div>
    </section>
  );
};

export default VentiHandoff;
